import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails Launches Live Share, Real-Time Location Sharing" />,
  date: 'March 12, 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails Launches Live Share, Real-Time Location Sharing" />
      </Typography>

      <Typography variant="paragraph100">
        <FormattedMessage defaultMessage="San Francisco (March 12, 2024) —AllTrails, the world's largest and most trusted outdoor platform, today announced the launch of Live Share, a real-time location sharing service that allows people to stay connected with friends and family when they hit the trail. Live Share is the latest addition to AllTrails’ suite of trail discovery, safety, and planning features." />
        <br />
        <FormattedMessage defaultMessage="Sharing trail plans with others is key to exploring the outdoors safely. With Live Share, AllTrails+ members can invite loved ones to see their route information, progress along the trail, and expected return time. Those following a member’s activity can check in and celebrate their milestones on the trail." />
        <br />
        <FormattedMessage defaultMessage="When members use Live Share, their friends and family can: " />
        <br />
        <ul>
          <li>
            <FormattedMessage defaultMessage="Monitor the member’s progress on their planned route" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Be notified of the member’s start, finish, and key milestones along the way" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Cheer the member on with one-click encouragement" />
          </li>
          <li>
            <FormattedMessage defaultMessage="View the member’s last recorded location on the trail" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Check in with the member if they’re out past the estimated trail completion time" />
          </li>
          <li>
            <FormattedMessage defaultMessage="See the member’s battery life and cell service status" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Access the member’s trail details such as the route, elevation, weather conditions, sunset time, and more" />
          </li>
        </ul>
        <br />
        <FormattedMessage defaultMessage="“Live Share connects AllTrails members to their families and friends, even if they aren’t on the trail together,” said Ivan Selin, Chief Product Officer at AllTrails. “Whether it’s a short walk or a backpacking adventure, Live Share helps our members celebrate getting outdoors and gives their loved ones peace of mind.”" />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About AllTrails" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers. Every day, AllTrails is inspired to help get more people outside so they can have healthy, authentic experiences and a deeper appreciation of the outdoors. AllTrails was awarded Apple’s 2023 iPhone App of the Year and a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to AllTrails.com to learn more." />
      </Typography>
    </>
  )
};

export default pressRelease;
